import type { ServerStatus } from '@comficonf/shared';
import { cn } from '@/lib/utils';

/**
 * Online is a filled green dot; offline is a hollow neutral ring, so the two differ in shape as well as color. In
 * forced-colors mode the online dot is filled with `CanvasText`, since a forced background would match the canvas.
 */
export function StatusDot({ status, className }: { status: ServerStatus; className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        'inline-block size-2 shrink-0 rounded-full',
        status === 'online'
          ? 'bg-success forced-colors:bg-[CanvasText] forced-colors:forced-color-adjust-none'
          : 'border border-control-border',
        className,
      )}
    />
  );
}

export function StatusLabel({ status }: { status: ServerStatus }) {
  return (
    <span className="inline-flex items-center gap-1.5 text-sm font-medium">
      <StatusDot status={status} />
      <span className={status === 'online' ? 'text-success-soft-fg' : 'text-muted'}>
        {status === 'online' ? 'Online' : 'Offline'}
      </span>
    </span>
  );
}
